var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapMarkerUnselected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 35,
    viewBox: "0 0 25 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1205_4025)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.65454 29.263C9.65454 26.516 8.21454 24.2062 6.48654 21.9116L5.96065 21.2233L4.88469 19.8391L4.34843 19.1383L3.82254 18.4282C2.09454 16.0432 0.654541 13.4622 0.654541 10.263C0.654541 4.83373 4.98121 0.415038 10.3746 0.266812L10.6545 0.26297L10.9344 0.266812C16.3279 0.415038 20.6545 4.83373 20.6545 10.263C20.6545 13.4622 19.2145 16.0432 17.4865 18.4282L16.9607 19.1383L16.4244 19.8391L15.3484 21.2233L14.8225 21.9116C13.1809 24.0915 11.7993 26.285 11.6652 28.8541L11.6545 29.263C11.6545 29.263 11.6177 30.0047 10.6446 30.0047C9.67151 30.0047 9.65454 29.263 9.65454 29.263Z",
    fill: "#FF832A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.9259 21.5807L6.92359 21.5777L6.3977 20.8894L6.39772 20.8893L6.39488 20.8857L5.32148 19.5049L5.31892 19.5016L4.78785 18.8075L4.26625 18.1032C2.55982 15.7476 1.20454 13.2847 1.20454 10.263C1.20454 5.13368 5.29126 0.958707 10.386 0.816707L10.6545 0.813022L10.9231 0.816707C16.0178 0.958707 20.1045 5.13368 20.1045 10.263C20.1045 13.2847 18.7493 15.7475 17.0429 18.1032L16.5212 18.8076L15.9902 19.5016L15.9876 19.5049L14.9142 20.8857L14.9142 20.8857L14.9114 20.8894L14.3855 21.5777L14.3832 21.5807C12.7369 23.7669 11.2594 26.0769 11.1159 28.8255L11.1154 28.8398L11.1054 29.2237C11.1047 29.227 11.1037 29.2313 11.1024 29.2364C11.0962 29.2594 11.0847 29.289 11.0651 29.3168C11.0457 29.3442 10.9675 29.4547 10.6446 29.4547C10.3272 29.4547 10.2556 29.3486 10.2404 29.326L10.2397 29.325C10.2226 29.2997 10.2124 29.272 10.207 29.2497C10.2059 29.245 10.2051 29.2409 10.2045 29.2378C10.1957 26.3056 8.65362 23.875 6.9259 21.5807Z",
    stroke: "#888888",
    strokeWidth: 1.1,
    strokeLinejoin: "round",
    style: {
      mixBlendMode: "multiply"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1205_4025",
    x: 0.654541,
    y: 0.26297,
    width: 24,
    height: 33.7418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1205_4025"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1205_4025",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerUnselected);
export default __webpack_public_path__ + "static/media/map-marker-unselected.7bc9eff6cf20df63d5a11e98f00e9809.svg";
export { ForwardRef as ReactComponent };